module.exports = __webpack_public_path__ + "static/media/Logo-vd.a8b18d9d.png";